import { API, getAuthToken } from "@/lib/api";

// Same-origin <a> navigations send the httpOnly auth cookie automatically.
// Append the in-memory token only when present (e.g. right after login this session).
function withAuth(url) {
  const token = getAuthToken();
  return token ? `${url}${url.includes("?") ? "&" : "?"}auth=${encodeURIComponent(token)}` : url;
}

export function fileViewUrl(docId) {
  return withAuth(`${API}/documents/${docId}/download`);
}

export function pdfUrl(path) {
  return withAuth(`${API}/${path}`);
}
